import { useStores } from 'src/models';

/**
 * 수정 권한이 있는 권한 그룹 SID 목록
 * 300: ADMIN
 */
const ALLOWED_USER_GROUP_SIDS = [300];

/**
 * 자리배치도 수정 권한 체크 Hook
 */
export const useEditPermission = (): boolean => {
  const { authStore } = useStores();
  const userGroupList = authStore.user?.userGroupList ?? [];

  return userGroupList.some((group) => ALLOWED_USER_GROUP_SIDS.includes(group.userGroupSid));
};
